import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';

export const LeagueRewardTierSchema = defineSchema({
  name: 'serverLeagueRewards',
  fields: [
    ['rewardTableId', 'string'],
    ['minRank', 'number'],
    ['maxRank', 'number'],
    ['rewards', { kind: 'dict', dict: 'delivery' }],
  ],
  lookupKeys: ['rewardTableId'],
});

export interface RawLeagueRewardTierRow {
  reward_table_id: string;
  min_rank: number;
  max_rank: number;
  rewards: Record<string, number>;
}

export function leagueRewardTierFromRaw(row: RawLeagueRewardTierRow) {
  return {
    rewardTableId: row.reward_table_id,
    minRank: row.min_rank,
    maxRank: row.max_rank,
    rewards: row.rewards,
  };
}

registerCategorySchema('serverLeagueRewards', LeagueRewardTierSchema);
